<app-breadcrumb [title]="'Employees'"></app-breadcrumb>
<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="card mb-3">

        <div class="card-body">
          <div class="row g-3">
            <div class="col-2">
              <select id="financialYearId" class="form-select mb-2 mr-sm-2" [(ngModel)]="query.financialYearId" #financialYearId="ngModel"  (change)="onYearChange($event.target.value)">
                  <option value="0" selected>--ALL Year--</option>
                  <option *ngFor="let item of financialYears" [value]="item.value">{{ item.text }}
                  </option>
                </select>
          </div>
            <div class="col-2">
              <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.regionId" #regionId="ngModel"
                (change)="getStates($event.target.value)">
                <option value="" selected>--SELECT REGION--</option>
                <option *ngFor="let item of regions" [value]="item.value">{{ item.text }}
                </option>
              </select>
            </div>
            <div class="col-2">
              <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.stateId" #stateId="ngModel"
                (change)="getDistricts($event.target.value)">
                <option value="" selected>--SELECT STATE--</option>
                <option *ngFor="let item of states" [value]="item.value">{{ item.text }}
                </option>
              </select>
            </div>
            <div class="col-2">
              <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.districtId" #districtId="ngModel"
                (change)="getSchools($event.target.value)">
                <option value="" selected>--SELECT DISTRICT--</option>
                <option *ngFor="let item of districts" [value]="item.value">{{ item.text }}
                </option>
              </select>
            </div>
            <div class="col-2">
              <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.schoolId" #schoolId="ngModel">
                <option value="" selected>--SELECT SCHOOL--</option>
                <option *ngFor="let item of schools" [value]="item.value">{{ item.text }}
                </option>
              </select>
            </div>
            <div class="col-2">
              <select class="form-select mb-2 mr-sm-2" [(ngModel)]="query.designationId" #designationId="ngModel">
                <option value="" selected>--SELECT DESIGNATION--</option>
                <option *ngFor="let item of designations" [value]="item.value">{{ item.text }}
                </option>
              </select>
            </div>
            <div class="col-2">
              <label class="visually-hidden" for="shalaId">Shala ID</label>
              <input type="text" placeholder="Shala ID" class="form-control mb-2 mr-sm-2" [(ngModel)]="query.shalaId"
                #shalaId="ngModel" />
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-success" (click)="filter()">Search</button>
          </div>
        </div>

        <app-loader [show]="loading"></app-loader>
        <ng-container *ngIf="setting?.financialYearId == query.financialYearId; else noData">
        <div class="card-body" [class.d-none]="loading">
          <div *ngIf="queryResult.items" class="table-responsive">
            <table class="table align-items-center table-hover">
              <colgroup>
                <col style="width: 20%">
                <col style="width: 20%">
                <col style="width: 20%">
                <col style="width: 20%">
                <col style="width: 20%">
              </colgroup>
              <thead class="table-light">
                <tr>
                  <th *ngFor="let c of columns">
                    <div *ngIf="c.isSortable" (click)="sortBy(c.key)">
                      <div class="d-flex justify-content-between align-items-center">
                        {{ c.title }}
                        <div class="ml-2">
                          <i *ngIf="query.sort === c.key" class="fas"
                            [class.fa-sort-down]="query.sortDir == 'Ascending'"
                            [class.fa-sort-up]="query.sortDir == 'Descending'"></i>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="!c.isSortable">
                      {{ c.title }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let v of queryResult.items; let i=index;">
                  <td>{{ (queryResult.pageSize * queryResult.pageNumber + i) - 9 }}</td>
                  <td>{{ v.firstName + ' ' + v.middleName + ' ' + v.lastName }}</td>
                  <td>{{ getServiceBook(v.serviceBooks)?.designation?.name }}</td>
                  <td>{{ getServiceBook(v.serviceBooks)?.school?.name }}</td>
                  <td>
                    <span *ngIf="v.isROApproved == null" class="badge bg-warning">Pending</span>
                    <span *ngIf="v.isROApproved != null && v.isROApproved" class="badge bg-success">Approved</span>
                    <span *ngIf="v.isROApproved != null && !v.isROApproved" class="badge bg-danger">Rejected</span>
                  </td>
                  <td>
                    <a class="btn btn-sm" [routerLink]="['/admin/employee-profile/view-profile', v.userId,query.financialYearId]"
                      routerLinkActive="router-link-active">
                      <i-bs name="eye" width="1em" height="1em"></i-bs>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <pagination [total-rows]="queryResult.totalRows" [current-page]="query.page" [page-size]="query.pageSize">
          </pagination>
        </div>
      </ng-container>
      <ng-template #noData>
        <div class="card-body" [class.d-none]="loading">
          <div *ngIf="queryResult.items" class="table-responsive">
            <table class="table align-items-center table-hover">
              <colgroup>
                <col style="width: 10%">
                <col style="width: 20%">
                <col style="width: 20%">
                <col style="width: 15%">
                <col style="width: 15%">
              </colgroup>
              <thead class="table-light">
                <tr>
                  <th *ngFor="let c of columns">
                    <div *ngIf="c.isSortable" (click)="sortBy(c.key)">
                      <div class="d-flex justify-content-between align-items-center">
                        {{ c.title }}
                        <div class="ml-2">
                          <i *ngIf="query.sort === c.key" class="fas"
                            [class.fa-sort-down]="query.sortDir == 'Ascending'"
                            [class.fa-sort-up]="query.sortDir == 'Descending'"></i>
                        </div>
                      </div>
                    </div>
                    <div *ngIf="!c.isSortable">
                      {{ c.title }}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let v of profileLogs; let i=index;">
                  <td>{{ (queryResult.pageSize * queryResult.pageNumber + i) - 9 }}</td>
                  <td>{{ v.firstName + ' ' + v.middleName + ' ' + v.lastName }}</td>
                  <td>{{ school[i]?.name }}</td>  <!-- Access school using index -->
                    <td>{{ designation[i]?.name }}</td>  <!-- Access designation using index -->
                  <td>
                    <span *ngIf="v.isROApproved == null" class="badge bg-warning">Pending</span>
                    <span *ngIf="v.isROApproved != null && v.isROApproved" class="badge bg-success">Approved</span>
                    <span *ngIf="v.isROApproved != null && !v.isROApproved" class="badge bg-danger">Rejected</span>
                  </td>
                  <td>
                    <span *ngIf="v.isPrincipalApproved == null" class="badge bg-warning">Pending</span>
                    <span *ngIf="v.isPrincipalApproved != null && v.isPrincipalApproved" class="badge bg-success">Approved</span>
                    <span *ngIf="v.isPrincipalApproved != null && !v.isPrincipalApproved" class="badge bg-danger">Rejected</span>
                  </td>
                  <td>
                    <a class="btn btn-sm" [routerLink]="['/management/employees/viewprofile', v.userId,query.financialYearId]"
                      routerLinkActive="router-link-active">
                      <i-bs name="eye" width="1em" height="1em"></i-bs>
                    </a>
                  </td>
                  <!-- <td *ngIf="yearId != query.financialYearId">
                    <a class="btn btn-sm" [routerLink]="['/management/employees/view/log', v.userId,query.financialYearId]"
                      routerLinkActive="router-link-active">
                      <i-bs name="eye" width="1em" height="1em"></i-bs>
                    </a>
                  </td> -->
                </tr>
              </tbody>
            </table>
          </div>
          <pagination [total-rows]="queryResult.totalRows" [current-page]="query.page" [page-size]="query.pageSize">
          </pagination>
        </div>
      </ng-template>
      </div>
    </div>
  </div>
</div>